<!-- =========================================================================================
    File Name: ChartBarChart.vue
    Description: Create bar chart
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <chartjs-component-bar-chart :height=100 :data="data" :options="options"></chartjs-component-bar-chart>
  </div>
</template>

<script>
import ChartjsComponentBarChart from "./ChartjsComponentBarChart.vue"
export default {
    data() {
      return {
        
      }
    },
    components: {
      ChartjsComponentBarChart
    },
    props:{
      data:{
        type:Object,
        required:true,
      },
      options:{
        type:Object,
        required:true,
      }
    }
}
</script>